import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import HMapLabel from '../../components/HMapLabel'
import HMapBubbleSlider from '../../components/HMapBubbleSlider'
import HMapShadowSlider from '../../components/HMapShadowSlider'
import HMapColorSlider from '../../components/HMapColorSlider'
import HMapAutoComplete from '../../components/HMapAutoComplete'
import { WSpacer } from '../../components/HMapSpacer'
import { useHMapContext } from '../../hooks/useHMapContext'
import ApiCalls from '../../../../common/ApiCalls'
import { getOptionByValue } from '../../utils/heatmapFields'

const getMetric = (metrics, ref, key) => {
  const theMetric = metrics.filter(metric => metric['ref'] === ref)

  return !!theMetric?.length
    ? theMetric[0][key]
    : undefined
}

const HMapDetailsContentTabs = ({
  id,
  readonly,
  allHeatMaps,
  setAllHeatMaps
}) => {
  // console.log(id)
  const classes = useStyles()
  const [mapMetrics, setMapMetrics] = useState([])
  const { dynamicFieldsRef, operationsRef } = useHMapContext()
  const dynamicFields = dynamicFieldsRef.current
  const dynamicFieldsOptions = dynamicFields.map((field, idx) => ({
    value: field.id,
    text: field.label,
    index: idx
  }))

  const operations = operationsRef.current
  const operationsOptions = operations.map((field, idx) => ({
    value: field.value,
    text: field.text,
    index: idx
  }))

  useEffect(() => {
    const currentMapArray = allHeatMaps.filter((item) => item.id === id)
    const currentMap = currentMapArray?.length && currentMapArray[0]

    if (currentMap) {
      if (currentMap.metrics) return setMapMetrics([...currentMap.metrics])

      ApiCalls()
        .getAHeatmap(id)
        .then((res) => {
          const data = res?.data?.data
          const metrics = data?.metrics
          // console.log(data, metrics)
          metrics && setMapMetrics([...metrics])
          metrics &&
            setAllHeatMaps(
              [...allHeatMaps.map((item) =>
                item.id === id
                  ? { ...item, metrics: [...metrics] }
                  : { ...item }
              )]
            )

          // console.log(metrics)
        })
        .catch((err) => console.log(err))
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return (
    <div className={classes.root}>
      {mapMetrics.some(metric => dynamicFields.some(field => field.id === metric.field_id && field.config?.format === 'percentage')) && (
        <p>Percentage fields use a fixed 0–100% scale. Pin Value controls cluster aggregation. Older Sum or Count settings use Average until updated.</p>
      )}
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'20%'} text="Pin Style" fontType="h3" />
        <HMapLabel width={'50%'} text="1.Select Pin Data" fontType="h3" />
        <HMapLabel width={'30%'} text="2.Pin Value" fontType="h3" />
      </div>
      {/* Number */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Number" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              getMetric(mapMetrics, 'number', 'field_id')
            )}
            // setSelectedOption={setFieldValue}
            name={'numberField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              operationsOptions,
              getMetric(mapMetrics, 'number', 'calc')
            )}
            // setSelectedOption={setFieldValue}
            name={'numberCalc'}
            options={operationsOptions}
            readonly={readonly}
          />
        </div>
      </div>
      {/* Size */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Size" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              getMetric(mapMetrics, 'size', 'field_id')
            )}
            // setSelectedOption={setFieldValue}
            name={'sizeField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              operationsOptions,
              getMetric(mapMetrics, 'size', 'calc')
            )}
            // setSelectedOption={setFieldValue}
            name={'sizeCalc'}
            options={operationsOptions}
            readonly={readonly}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapBubbleSlider
            width={'80%'}
            disabled={readonly}
            // onChange={(newValue)=> console.log(newValue)}
            defaultValues={getMetric(mapMetrics, 'size', 'ranges')}
          />
        </div>
      </div>
      {/* Color */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Color" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              getMetric(mapMetrics, 'color', 'field_id')
            )}
            // setSelectedOption={setFieldValue}
            name={'colorField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              operationsOptions,
              getMetric(mapMetrics, 'color', 'calc')
            )}
            // setSelectedOption={setFieldValue}
            name={'colorCalc'}
            options={operationsOptions}
            readonly={readonly}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapColorSlider
            width={'80%'}
            disabled={readonly}
            defaultValues={getMetric(mapMetrics, 'color', 'ranges')}
            colors={getMetric(mapMetrics, 'color', 'color_hexes')}
          />
        </div>
      </div>
      {/* Shadow */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Shadow" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              getMetric(mapMetrics, 'shadow', 'field_id')
            )}
            // setSelectedOption={setFieldValue}
            name={'shadowField'}
            options={dynamicFieldsOptions || []}
            readonly={readonly}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              operationsOptions,
              getMetric(mapMetrics, 'shadow', 'calc')
            )}
            // setSelectedOption={setFieldValue}
            name={'shadowCalc'}
            options={operationsOptions}
            readonly={readonly}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapShadowSlider
            width={'80%'}
            disabled={readonly}
            // onChange={(newValue)=> console.log(newValue)}
            defaultValues={getMetric(mapMetrics, 'shadow', 'ranges')}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(HMapDetailsContentTabs)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '0px 10px'
  },
  panelMultiRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  panelRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 5px'
  },
  borderBottom: {
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  }
}))
